import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="country-typeahead"
export default class extends Controller {
  static targets = ["input", "list", "option"]

  filter() {
    const query = this.inputTarget.value.trim().toLowerCase()
    let anyVisible = false
    this.optionTargets.forEach((option) => {
      const match = option.dataset.value.toLowerCase().includes(query)
      option.hidden = !match
      if (match) anyVisible = true
    })
    this.listTarget.hidden = !anyVisible
  }

  select(event) {
    this.inputTarget.value = event.currentTarget.dataset.value
    this.close()
  }

  close() {
    this.listTarget.hidden = true
  }

  closeOnOutsideClick(event) {
    if (!this.element.contains(event.target)) this.close()
  }
}
